import { render, staticRenderFns } from "./phone-link.vue?vue&type=template&id=e9c6b870&functional=true&"
import script from "./phone-link.vue?vue&type=script&lang=js&"
export * from "./phone-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports